/**
 * DescriptionBackgroundContainer component.
 */
import styled from 'styled-components';

/**
 * Styled detail background container.
 */
const DescriptionBackgroundContainer = styled.div<{ $display: boolean }>`
  display: ${(props) => (props.$display ? 'visible' : 'none')};
  position: absolute;
  height: 100vh;
  width: 100vw;
`;

export default DescriptionBackgroundContainer;
